<template>
  <div class="yiliao">
	<el-radio-group v-model="tabPosition1" @change="change">
      <el-radio-button label="1">
        <i class="el-icon-data-board"></i>
        <span>字段数据</span>
      </el-radio-button>
      <el-radio-button label="2">
        <i class="el-icon-data-line"></i>
        <span>图表趋势</span>
      </el-radio-button>
    </el-radio-group>
    <div class="u-flex u-col-center u-row-between u-flex-wrap" style="padding: 30px 0px;" v-show="tabPosition1==1">
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">行政区划代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.administrative}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">地级市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.city}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">区县城市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.area}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;" v-if="datainfo.name">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">医院名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.name}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;" v-if="datainfo.pharmacy_name">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">药房名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.pharmacy_name}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">企业名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.enterprise}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">是否医保定点</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.medical}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">单体/连锁</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.type}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">法定代表人</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.legal_person}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">地址</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.address}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">联系电话</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.tel}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">邮箱</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.mailbox}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">注册资本</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.capital}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">成立日期</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.incorporation}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">统一社会信用代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.credit}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">参保员工人数</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.insured}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">医疗收入</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">组织机构代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.organization}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">是否院边药房</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.is_have}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">临近相关建筑</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.adjacent}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">相关建筑距离（米）</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.distance}}</span>
			</div>
			  <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">经营范围</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.business}}</span>
			</div>
			<div style="width: 220px;margin: 0 40px;"></div>
			<div style="width: 220px;margin: 0 40px;"></div>
		</div>
		 <div
      class="u-flex u-col-center u-row-between u-flex-wrap"
      style="padding: 50px 0 100px 0"
      v-show="tabPosition1 == 2"
    >
      <div style="width: 25%; height: 225px" id="bing1"></div>
      <div style="width: 25%; height: 225px" id="bing2"></div>
      <div style="width: 25%; height: 225px" id="bing3"></div>
      <div style="width: 25%; height: 225px" id="bing4"></div>
      <div style="width: 25%; height: 225px" id="bing5"></div>
      <div style="width: 25%; height: 225px" id="bing6"></div>
      <div style="width: 25%; height: 225px" id="bing7"></div>
      <div style="width: 25%; height: 225px" id="bing8"></div>
    </div>
        <!-- <div class="u-flex" style="margin-left:40px">
            <span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 96px;">经营范围</span>
				<span style="line-height:50px;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 1144px;padding-left: 16px;">{{datainfo.business}}</span>
        </div> -->

  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    created(){
        this.datainfo=JSON.parse(this.$route.query.item)
        if(this.datainfo.name){
          this.$route.meta.title=this.datainfo.name

        }else{
          
        this.$route.meta.title=this.datainfo.pharmacy_name

        }
    // this.changeselect();

    },
    data(){
        return{
			 tabPosition1: "1",
             datainfo: {},
        }
    },
    methods:{
		change(e) {
       if (e == 2) {
        this.setbing();
      }
    },
	setbing() {
      var arr = [
        "床位书全市占比",
        "职业_助理医师全市占比",
        "门急诊人次全市占比",
        "住院手术人次数全市占比",
        "医疗收入全市占比",
        "医疗支出全市占比",
        "门诊收入全市占比",
        "门诊收入全市占比",
      ];

      arr.forEach((val, key) => {
        var chartDom = document.getElementById(`bing${key + 1}`);
        var myChart = echarts.init(chartDom);
        myChart.setOption({
          // legend: {},
          tooltip: {},
          graphic: {
            type: "text",
            left: "center",
            bottom: "0",
            style: {
              text: val,
              textAlign: "center",
              fill: "#222",
              fontSize: 14,
              fontWeight: 400,
            },
          },
          series: [
            {
              name: val,
              type: "pie", // 设置图表类型为饼图
              radius: "45%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
              label: {
                show: false,
              },
              itemStyle: {
                normal: {
                  color: function (colors) {
                    var colorList = ["#4B87FF", "#22D66C", "#5D7092"];
                    return colorList[colors.dataIndex];
                  },
                },
              },
              data: [
                // 数据数组，name 为数据项名称，value 为数据项值
                {
                  value: 235,
                  name: "视频广告",
                },
                {
                  value: 274,
                  name: "联盟广告",
                },
                {
                  value: 310,
                  name: "邮件营销",
                },
              ],
            },
          ],
        });
      });
    },
        changeselect() {
      this.$http({
        url: "/api/Bigdata/hospital_show",
        data: {
          grade: this.value2,
          lable: this.value3,
          type: this.value4,
          sheng: this.value1,
        },
      }).then((res) => {
        this.datainfo = res.data;
      });
    },
    }
}
</script>

<style lang="scss">
.yiliao {
  width: 1400px;
  // height: 840px;
  background: #ffffff;
  margin: 20px auto;
  padding: 30px 40px;

  .el-input__suffix {
    right: 0;
  }
  .lianji {
    .el-cascader {
      line-height: 38px;
      height: 38px;
    }

    .el-input__inner {
      border: none;
      line-height: 38px;
      height: 38px;
      background-color: #f7f7f7;
    }
  }
}
</style>
